// import translations from 'utils/helpers/localization'
import {
  COLOR_ERROR,
  COLOR_E28902,
  COLOR_1DAE34,
  COLOR_BLACK_666666,
  COLOR_BLACK_D3D3D3,
  COLOR_PURPLE,
  COLOR_EBE7F6,
  COLOR_BLACK_959595,
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_YELLOW,
  COLOR_BLACK_333333,
  COLOR_PINK,
  COLOR_6F1919
} from '../../assets/colors'
// import { MatchDetails, NXTournament, TournamentStatus, WidgetStyle } from 'src/types/typesLudoNX'
import _isNil from 'lodash/isNil'
// import { getCurrentTimestamp } from 'utils/ZupeeClock'
import { formatTimestampTo, getCurrentTimestamp } from '../../utils/DateUtils'
import _isEmpty from 'lodash/isEmpty'
import { getResultOutTimeFormat } from './common'
import { MatchDetails, TournamentStatus, WidgetItem, WidgetStyle } from '../../interfaces/TournamentsConfig'
import { PLAYER_NUMBER } from '../../pages/GamePlay/types'
import { TFunction } from 'i18next'

interface TimerTextResult {
  timerText: string;
  textColor: string;
}

function showMatchDetails(matchDetails: MatchDetails | undefined) {
  return !_isNil(matchDetails)
}

function isSlotsAvailable(maxParticipants: number | undefined, numRegistrations: number | undefined): boolean {
  if (_isNil(maxParticipants) || _isNil(numRegistrations)) return false
  return maxParticipants > numRegistrations
}

export function getTournamentCurrentStatus(tournament: WidgetItem): TournamentStatus {
  const currentTime = getCurrentTimestamp() as number
  const registrationStartTime = tournament?.registrationStartTime || 0
  const registrationEndTime = tournament?.registrationEndTime || 0
  const resultDeclareTime = tournament?.resultDeclareTime || 0
  const displayEndTime = tournament?.displayEndTime || 0
  const playingAttempt = tournament?.playingAttempt || 0
  const maxPlayingAttempt = tournament?.maxPlayingAttempt || 0

  if (currentTime < registrationStartTime) {
    return TournamentStatus.TOURNAMENT_NOT_STARTED
  }

  if (currentTime >= registrationStartTime && currentTime < registrationEndTime) {
    if (playingAttempt > 0) {
      return playingAttempt < maxPlayingAttempt
        ? TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING
        : TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING
    } else {
      return TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED
    }
  }

  if (currentTime >= registrationEndTime && currentTime < resultDeclareTime) {
    return TournamentStatus.TOURNAMENT_CLOSED_RESULT_PENDING
  }

  if (currentTime > displayEndTime) {
    return TournamentStatus.TOURNAMENT_CLOSED_DISPLAY_ENDED
  }

  if (currentTime > resultDeclareTime) {
    return TournamentStatus.TOURNAMENT_CLOSED_RESULT_OUT
  }

  return TournamentStatus.TOURNAMENT_NOT_STARTED
}

export function showTimerTextNX(nxTournament: WidgetItem | undefined, ignoreShowTimerFlag : boolean = false) {
  if (_isNil(nxTournament) || nxTournament?.isSuspended) {
    return false
  }
  if (!ignoreShowTimerFlag && !nxTournament?.showTimer) {
    return false
  }

  switch (getTournamentCurrentStatus(nxTournament)) {
    case TournamentStatus.TOURNAMENT_NOT_STARTED:
      return true
    case TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED:
    case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING:
      return isSlotsAvailable(nxTournament?.maxParticipants, nxTournament?.numRegistrations)

  }
  return false
}

export function getNxTimerText(nxTournament: WidgetItem | undefined, t?: any): TimerTextResult {
  
  let timerText = ''
  let textColor = ''

  // if (_isNil(nxTournament) || !nxTournament?.showTimer) {
  if (_isNil(nxTournament)) {

    return { timerText: '', textColor: '' } // Return empty values if showTimer is false
  }

  if (nxTournament?.isSuspended) {
    timerText = t('cancelled')
    // timerText= "cancelled"
    textColor = COLOR_ERROR
  } else {
    switch (getTournamentCurrentStatus(nxTournament)) {
      case TournamentStatus.TOURNAMENT_NOT_STARTED:
        timerText = showMatchDetails(nxTournament?.matchDetails) && nxTournament?.tournamentStartTimeText
          ? nxTournament?.tournamentStartTimeText
          : t('nx_starts_in')
        textColor = COLOR_E28902
        break

      case TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED:
      case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING:
        if (isSlotsAvailable(nxTournament?.maxParticipants, nxTournament?.numRegistrations)) {
          timerText = showMatchDetails(nxTournament?.matchDetails) && nxTournament?.tournamentEndTimeText
            ? nxTournament?.tournamentEndTimeText
            : t('nx_closes_in')
          textColor = COLOR_1DAE34
        } else {
          timerText = showMatchDetails(nxTournament?.matchDetails) && nxTournament?.tournamentResultOutTimeText
            ? nxTournament?.tournamentResultOutTimeText
            : t('results_at', {
              time: formatTimestampTo(nxTournament?.resultDeclareTime, getResultOutTimeFormat(nxTournament?.resultDeclareTime))
            })
            // : "Result time out"
          textColor = COLOR_1DAE34
        }
        break

      case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING:
      case TournamentStatus.TOURNAMENT_CLOSED_RESULT_PENDING:
        timerText = showMatchDetails(nxTournament?.matchDetails) && nxTournament?.tournamentResultOutTimeText
          ? nxTournament?.tournamentResultOutTimeText
          : t('results_at', {
            time: formatTimestampTo(nxTournament?.resultDeclareTime, getResultOutTimeFormat(nxTournament?.resultDeclareTime))
          })
          // : "Result time out"
        textColor = COLOR_1DAE34
        break

      case TournamentStatus.TOURNAMENT_CLOSED_RESULT_OUT:
      case TournamentStatus.TOURNAMENT_CLOSED_DISPLAY_ENDED:
        timerText = t('check_results_now')
        // timerText = "Check results now"
        textColor = COLOR_1DAE34
        break

      default:
        break
    }

    if (nxTournament?.isLocked) {
      timerText = t('locked')
      // timerText = "Locked"
      textColor = COLOR_E28902
    }
  }

  return { timerText, textColor }
}

export function isMegaTournament(tag: string | undefined) {
  return tag === 'MEGA'
}

export function isMahaMegaTournament(tag: string) {
  return tag === 'MAHA_MEGA'
}

export function showLockIconOnTimer(isLocked: boolean, showTimer: boolean): boolean {
  return isLocked && showTimer
}

export function showSeriesName(matchDetails: MatchDetails): boolean {
  return !_isEmpty(matchDetails?.seriesName)
}

export function isTagVisible(tag: string | undefined, displayTag: string | undefined): boolean {
  return isMegaTournament(tag) || !_isEmpty(displayTag)
}

export function isSuspendedOrReferral(isSuspended: boolean, isReferralNxTournament: boolean) {
  return isSuspended || isReferralNxTournament
}

export function getTagText(displayTag: string, tag: string): string | undefined {
  if (displayTag) {
    return displayTag
  } else {
    return tag
  }
}

export function tagImage(isSuspended: boolean | undefined, isReferralNxTournament: boolean | undefined) {
  if (isSuspended) {
    return { edgeColor: COLOR_BLACK_333333, stripColor: COLOR_BLACK }
  } else if (isReferralNxTournament) {
    return { edgeColor: COLOR_BLACK, stripColor: COLOR_PURPLE }
  } else {
    return { edgeColor: COLOR_6F1919, stripColor: COLOR_PINK }
  }
}

export function getBackgroundColor(isSuspended: boolean, tag: string): string {
  if (isSuspended && isMegaTournament(tag)) {
    return COLOR_BLACK_666666
  }

  if (isSuspended) {
    return COLOR_BLACK_D3D3D3
  }

  if (isMegaTournament(tag)) {
    return COLOR_PURPLE
  }

  return COLOR_EBE7F6
}

export function getTitleTextColor(style: WidgetStyle | undefined,
                                  isSuspended: boolean, tag: string,
                                  isReferralNxTournament: boolean): string {
  if (isReferralNxTournament && !isSuspended && style?.header) {
    return style.header
  } else if (isSuspended || isMegaTournament(tag)) {
    return COLOR_BLACK_959595
  } else {
    return COLOR_BLACK_666666
  }
}

export function getTextValueColor(style: WidgetStyle | undefined, isSuspended: boolean, tag: string,
                                  isReferralNxTournament: boolean): string {
  if (isReferralNxTournament && style?.titleHex) { //TODO Android has style?.title color but didn't receive it in API
    return style?.titleHex
  } else if (isSuspended || isMegaTournament(tag)) {
    return COLOR_WHITE
  } else {
    return COLOR_BLACK
  }
}

export const nxTournamentText = (nxTournament: WidgetItem, t: TFunction<"translation", undefined>) => {
  let title = ''
  let containerStyle = {}
  let textColor = ''

  //TODO More cases to be handled
  if (!isSlotsAvailable(nxTournament?.maxParticipants, nxTournament?.numRegistrations)) {
    // title = translations.regFull
    title = t('RegistrationFull')
  } else if (nxTournament.entryFee === 0) {
    // title = translations.free
    title = t('free')
  } else {
    title = nxTournament.generalInfo?.entryFeeText || ''
    // title = DiscountedEntryFeeHelper.canShowDiscountedEntryFee()
    //   ? DiscountedEntryFeeHelper.getDiscountedFee(nxTournament.entryFee)
    //   : nxTournament.generalInfo?.entryFeeText || ''
  }

  if (nxTournament.isSuspended) {
    containerStyle = { backgroundColor: COLOR_BLACK_D3D3D3 }
    textColor = COLOR_BLACK_959595
    return { title, containerStyle, textColor }
  }

  switch (getTournamentCurrentStatus(nxTournament)) {
    case TournamentStatus.TOURNAMENT_NOT_STARTED:
    case TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED:
    case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING:
    case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING:
      if (isSlotsAvailable(nxTournament?.maxParticipants, nxTournament?.numRegistrations)) {
        containerStyle = { backgroundColor: nxTournament.entryFee === 0 ? COLOR_1DAE34 : COLOR_YELLOW }
        textColor = nxTournament.entryFee === 0 ? COLOR_WHITE : COLOR_PURPLE
      } else {
        containerStyle = { backgroundColor: COLOR_BLACK_D3D3D3 }
        textColor = COLOR_BLACK_959595
      }
      break
    case TournamentStatus.TOURNAMENT_CLOSED_RESULT_PENDING:
    case TournamentStatus.TOURNAMENT_CLOSED_RESULT_OUT:
    case TournamentStatus.TOURNAMENT_CLOSED_DISPLAY_ENDED:
      containerStyle = { backgroundColor: COLOR_BLACK_D3D3D3 }
      textColor = COLOR_BLACK_959595
      break
  }

  return { title, containerStyle, textColor }
}

export function showMinuteTimer(currentTime: number, registrationStartTime: number, registrationEndTime: number) {
  return currentTime > registrationStartTime && currentTime < registrationEndTime
}

export function getIconColors(isSuspended: boolean, tag: string) {

  if (isSuspended && isMegaTournament(tag)) {
    return { iconBackgroundColor: COLOR_WHITE, highlightColor: COLOR_BLACK_959595 }
  }

  if (isSuspended) {
    return { iconBackgroundColor: COLOR_WHITE, highlightColor: COLOR_BLACK_D3D3D3 }
  }

  if (isMegaTournament(tag)) {
    return { iconBackgroundColor: COLOR_EBE7F6, highlightColor: COLOR_PURPLE }
  }
  return { iconBackgroundColor: COLOR_WHITE, iconColor: COLOR_PURPLE }
}

export function getPlayerNumberForSeatIndex(
  totalPlayers?: number,
  mySeatIndex?: number | null,
  seatIndex?: number | null
): PLAYER_NUMBER {
  if (_isNil(mySeatIndex)) {
    return PLAYER_NUMBER.ONE
  }
  if (seatIndex === mySeatIndex) {
    return PLAYER_NUMBER.ONE
  }
  if (totalPlayers === 2) {
    return PLAYER_NUMBER.THREE
  }
  if (totalPlayers === 3) {
    if (seatIndex === (mySeatIndex + 1) % 3) {
      return PLAYER_NUMBER.TWO
    }
    return PLAYER_NUMBER.THREE
  }
  if (seatIndex === (mySeatIndex + 1) % 4) {
    return PLAYER_NUMBER.TWO
  }
  if (seatIndex === (mySeatIndex + 2) % 4) {
    return PLAYER_NUMBER.THREE
  }
  return PLAYER_NUMBER.FOUR
}


